



























import { defineComponent } from '@nuxtjs/composition-api';
import { SfImage } from '@storefront-ui/vue';

export default defineComponent({
  name: 'ImageWithHover',
  components: {
    SfImage,
  },
  props: {
    isHovered: {
      type: Boolean,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
    hoverSrc: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    srcsets: {
      type: Array,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    loading: {
      type: String,
      default: 'eager',
    },
    className: {
      type: String,
    },
  },
});
